<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Navigation -->
<fuse-vertical-navigation class="dark bg-green-default print:hidden" [appearance]="'compact'"
    [mode]="isScreenSmall ? 'over' : 'side'" [name]="'mainNavigation'" [navigation]="navigation.compactCompany"
    [opened]="!isScreenSmall">
    <!-- Navigation header hook -->
    <ng-container fuseVerticalNavigationContentHeader>
        <!-- Logo -->
        <div class="flex items-center justify-center h-20 mt-3 mb-4 cursor-pointer" (click)="onLogoClick()">
            <img class="w-16" src="images/logo/logow.png" [alt]="'ui.LogoImage' | transloco">
        </div>
    </ng-container>
</fuse-vertical-navigation>

<!-- Wrapper -->
<div class="flex flex-col flex-auto w-full min-w-0">

    <!-- Header -->
    <div
        class="relative flex flex-0 items-center w-full h-16 px-4 md:px-6 z-49 shadow dark:shadow-none dark:border-b bg-card dark:bg-transparent print:hidden">
        <!-- Navigation toggle button -->
        <div class="flex items-center">
            <div class="">
                <button mat-icon-button (click)="toggleNavigation('mainNavigation')">
                    <mat-icon [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
                </button>
            </div>
            <div class="ml-2">
                <div class="flex flex-col justify-center">
                    <div class="text-xl font-medium">
                        {{ company?.title || project?.title}}
                    </div>
                    <div class="text-sm text-gray-600 mt-0.5">
                        {{ 'ui.ManageCompanyInformation' | transloco }}
                    </div>

                </div>
                <!-- {{ 's.l.HQ' | transloco }} -->

            </div>
        </div>
        <!-- Button -->
        <!-- <button mat-button (click)="clickBack()">
            {{ 's.btn.backToProject' | transloco }}
        </button> -->

        <!-- Components -->
        <div class="flex items-center pl-2 ml-auto space-x-0.5 sm:space-x-2">

            <languages></languages>

            <user [project]="project"></user>
        </div>
    </div>

    <!-- Low blockchain wallet balance alert -->
    <div class="px-4 md:px-6 pt-4" *ngIf="showLowBalanceAlert && !lowBalanceAlertDismissed">
        <fuse-alert [appearance]="'soft'" [type]="'warning'" [showIcon]="true" [dismissible]="true"
            (dismissedChanged)="lowBalanceAlertDismissed = $event">
            Blockchain stamping is enabled for this company, but its blockchain wallet balance ({{ walletBalance }}
            credits) has dropped below the recommended minimum of {{ walletLowBalanceThreshold }} credits. Top up the
            wallet to avoid disruption to blockchain stamping.
        </fuse-alert>
    </div>

    <!-- Content -->
    <div class="flex flex-col flex-auto">
        <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
             Otherwise, layout changes won't be registered and the view won't be updated! -->
        <router-outlet *ngIf="true"></router-outlet>
    </div>

    <!-- Footer -->
    <div
        class="relative flex flex-0 items-center justify-between w-full h-10 px-4 md:px-6 z-49 border-t bg-card dark:bg-transparent print:hidden">
        <div class="">
            <span class="font-medium text-secondary">iTrace &copy; {{currentYear}}</span>
        </div>
        <div class="text-right">v{{appVersion}}</div>
    </div>

</div>